import React from 'react';

interface VerticalDividerProps {
  testId?: string;
  className?: string;
}

export const VerticalDivider: React.FC<VerticalDividerProps> = ({
  testId,
  className,
}) => {
  return <div data-testid={testId} className={`${className} w-[1px]`}></div>;
};
